import React from 'react'
export const Footer = (props) => {
  
  return (
    <div>
      <div id='footer'>
        <div className='container text-center'>
          
          <p>
            &copy; 2021 Studeo 
            
          </p>
          <p>
             andreasink17@gmail.com 
            
          </p>
        
         
          <div class="flex hstack">
          <a class="fa fa-twitter" href='https://twitter.com/app_studeo' rel='nofollow'>
            
            </a>
            <a class="fa fa-apple" href='https://testflight.apple.com/join/njhzGKzs' rel='nofollow'>
            
            </a>
            </div>
        </div>
      </div>
    </div>
  )
}
